import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { EMPTY_EMPRESA } from "./empresaHelpers";

// Estado do dialog Nova/Editar Empresa. `set` aceita patch objeto ou função (prev) => patch.
export function useEmpresaForm(refreshEmpresas) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null); // empresa sendo editada (null => criando)
  const [f, setF] = useState(EMPTY_EMPRESA);
  const logoRef = useRef(null);

  const set = (patch) => setF((prev) => ({ ...prev, ...(typeof patch === "function" ? patch(prev) : patch) }));
  const openNew = () => { setEditing(null); setF(EMPTY_EMPRESA); setOpen(true); };
  const openEdit = (e) => { setEditing(e); setF({ ...EMPTY_EMPRESA, ...e }); setOpen(true); };
  const close = () => { setOpen(false); setEditing(null); };

  const save = async () => {
    if (!f.nome?.trim()) return toast.error("Nome é obrigatório");
    try {
      if (editing) {
        await api.put(`/empresas/${editing.id}`, f);
        toast.success("Empresa atualizada");
      } else {
        await api.post("/empresas", f);
        toast.success("Empresa criada");
      }
      setOpen(false); setEditing(null); setF(EMPTY_EMPRESA);
      await refreshEmpresas();
      // Notifica as outras páginas (Entregas, Layout, etc.) para recarregarem os dados da empresa
      window.dispatchEvent(new Event("empresa-changed"));
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  const uploadLogo = (ev) => {
    const file = ev.target.files?.[0]; if (!file) return;
    if (file.size > 2 * 1024 * 1024) return toast.error("Logo máx 2MB");
    const reader = new FileReader();
    reader.onload = () => set({ logo_base64: reader.result });
    reader.readAsDataURL(file);
    ev.target.value = "";
  };

  return { open, editing, f, set, logoRef, openNew, openEdit, close, save, uploadLogo };
}
